import {
  ColumnGroupValue,
  FieldsGroups,
  FieldType,
} from '../../modules/reporting/reports-builder/services/reports-builder/responses/settings.response';
import { FILTER_FIELDS_TRANSLATIONS } from '../../modules/reporting/reports-builder/services/reports-builder/translations.const';

export const getColumnGroupName = (fields: FieldType): string[] => Array.from(new Set(Object.values(fields).map(({ group }) => group)));

export const getColumnGroup = (fields: FieldType, groups: string[]): FieldsGroups => {
  const entriesFields = Object.entries(fields);
  const acc = {};
  for (const groupName of groups) {
    acc[groupName] = entriesFields
      .filter((entry) => entry[1].group === groupName)
      .map(([key, value]) => ({
        key,
        label: FILTER_FIELDS_TRANSLATIONS[value.name] || value.name,
      }));
  }

  return acc;
};

export const getColumnsKey = (groups: FieldsGroups | ColumnGroupValue): string[] => {
  const fields = Object.values(groups).map((data) => data.map(({ key }) => key as string));
  return [].concat(...fields);
};

export const getColumnGroupValue = (columnGroup: FieldsGroups, columnKeys: string[]): ColumnGroupValue => {
  return Object.entries(columnGroup).reduce(
    (acc, [groupName, fields]) => ({
      ...acc,
      [groupName]: fields.filter(({ key }) => columnKeys.includes(key as string)).map(({ key }) => ({ key })),
    }),
    {}
  );
};

export const mapQueryFilters = (group: string, filters: { [key: string]: any }): { [key: string]: any } => {
  return Object.entries(filters || {}).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [queryFilterHelper(group, key)]: value,
    }),
    {}
  );
};

function queryFilterHelper(group: string, value: string): string {
  switch (value) {
    case 'offer_id':
      return 'offers.id';
    case 'advertiser_id':
      return 'advertisers.id';
    case 'affiliate_id':
      return 'affiliates.id';
    case 'finance_earning_id':
      return 'finance_earnings.id';
    case 'finance_invoice_id':
      return 'finance_invoices.id';
    case 'finance_payment_id':
      return 'finance_payments.id';
    case 'finance_earning_status':
      return 'finance_earnings.status';
    case 'finance_invoice_status':
      return 'finance_invoices.status';
    case 'finance_payment_status':
      return 'finance_payments.status';
  }

  if (group === 'conversions') {
    switch (value) {
      case 'goal_id':
        return 'goals.id';
      case 'offer_id':
      case 'clicks.offer_id':
        return 'offers.id';
      case 'advertiser_id':
      case 'clicks.advertiser_id':
        return 'advertisers.id';

      default:
        return value;
    }
  }

  return `${group}.${value}`;
}
